import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "../lib/api";

const day = (iso) => new Date(iso).toLocaleDateString("id-ID", { timeZone: "Asia/Jakarta", day: "numeric", month: "long", year: "numeric" });
const span = (a, b) => {
  const d = Math.max(0, Math.round(((b ? new Date(b) : new Date()) - new Date(a)) / 86400000));
  return d < 31 ? `${d} hari` : d < 365 ? `${Math.floor(d / 30)} bulan` : `${(d / 365).toFixed(1).replace(".", ",")} tahun`;
};
const ROLE = { INVESTOR: "Investor", SUPER_ADMIN: "PT SJI" };

export const ManagerHistory = ({ projectId, refreshKey }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get(`/projects/${projectId}/manager-history`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [projectId, refreshKey]);
  if (!rows?.length) return null;
  return (
    <div className="bg-white border rounded-xl p-5" data-testid="manager-history">
      <p className="mb-4 flex items-center gap-2 text-sm font-semibold text-slate-900"><History className="h-4 w-4 text-emerald-800" />Riwayat Pengelola Kebun</p>
      <ol className="relative space-y-4 border-l-2 border-emerald-100 pl-5">
        {rows.map((s, i) => (
          <li key={`${s.start}-${i}`} className="relative" data-testid={`manager-history-item-${i}`}>
            <span className={`absolute -left-[27px] top-1 h-3 w-3 rounded-full border-2 border-white ${s.current ? "bg-emerald-600" : "bg-slate-300"}`} />
            <div className="flex flex-wrap items-center gap-2">
              <p className="font-bold text-slate-900 break-words" data-testid={`manager-history-name-${i}`}>{s.managerName}</p>
              <span className="text-xs text-slate-500">{s.managerKind}</span>
              {s.current && <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-bold text-emerald-800" data-testid={`manager-history-current-${i}`}>Saat ini</span>}
            </div>
            <p className="text-sm text-slate-700" data-testid={`manager-history-dates-${i}`}>
              {s.start ? day(s.start) : "Awal kebun"} — {s.end ? day(s.end) : "sekarang"}
              {s.start && <span className="text-xs text-slate-500"> · {span(s.start, s.end)}</span>}</p>
            <p className="text-xs text-slate-500">
              {s.assignedByName ? `Ditetapkan oleh ${s.assignedByName}` : "Pengelola awal kebun"}
              {s.proposedBy ? ` · diajukan oleh ${s.proposedBy.name} (${ROLE[s.proposedBy.role] || s.proposedBy.role})` : ""}</p>
          </li>))}
      </ol>
    </div>
  );
};
